
































import { Component, Vue } from 'vue-property-decorator';

import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import BoxProgramStatus from '@/componentsV2/molecules/BoxProgramStatus/BoxProgramStatus.vue';
import { IBusinessType } from '@/models/business';

@Component({
  components: {
    FilledButton,
    BoxProgramStatus
  }
})
export default class FeedbackStatus extends Vue {
  get businessInfo() {
    return this.$store.getters['business/getBusinessInfo'].business || {};
  }

  get programStatus() {
    return { operationType: IBusinessType.BOTH };
  }

  goToProgramStatus() {
    this.$emit('close');

    this.$router.push('/program-status');
  }

  onClose() {
    this.$emit('close');
  }
}
